import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../Interceptor/interceptor";


export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: baseApiQuery,
    tagTypes: ["posts"],
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (user) => ({
                url: 'login/',
                method: 'POST',
                body: user,
            })
        }),
        register: builder.mutation({
            query: (user) => ({
                url: 'customer/create/',
                method: 'POST',
                body: user,
            })
        }),
        changePassword: builder.mutation({
            query: (user) => ({
                url: 'user/chgpass/',
                method: 'POST',
                body: user,
            })
        }),
        forgotPassword: builder.mutation({
            query: (user) => ({
                url: 'user/forgotpassword/',
                method: 'POST',
                body: user,
            })
        }),
        resetPassword: builder.mutation({
            query: (user) => ({
                url: 'user/resetpassword/',
                method: 'POST',
                body: user,
            })
        })
    })
})

export const { useLoginMutation, useRegisterMutation, useChangePasswordMutation, useForgotPasswordMutation, useResetPasswordMutation } = authApi